import script from "./HomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=c876aaa0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c876aaa0"]])

export default __exports__